import React from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import UserViewEntry from "../userView/UserViewEntry";
import BackButton from "../common/BackButton";

export default function AlertEntrySmall() {
  const history = useHistory();
  const isNarrowScreen = window.innerWidth <= 360;
  const countyName = useSelector((state) => state.countyConfigCommonReducer.countyName);
  const appTitle = useSelector((state) => state.countyConfigCommonReducer.appTitle);
  const selectedAlert = useSelector((state) => state.userViewSelectedAlertReducer);

  const handleClose = () => {
    history.push("/home");
  };

  return (
    <div>
      {/* Banner */}
      <div style={styles.banner}>
        <div style={styles.logoContainer}>
          <BackButton onClick={handleClose} ariaLabel="Back to My Alerts" />
        </div>

        <div style={styles.titleContainer}>
          <div
            style={{
              ...styles.title,
              fontSize: isNarrowScreen ? "16px" : "20px",
            }}
          >
            {countyName}
          </div>
          <div
            style={{
              ...styles.subtitle,
              fontSize: isNarrowScreen ? "13px" : "16px",
            }}
          >
            {appTitle}
          </div>
        </div>

        <div style={styles.right} />
      </div>

      {/* Content */}
      <div style={styles.content}>
        <h2
          style={{
            ...styles.pageTitle,
            fontSize: isNarrowScreen ? "18px" : "20px",
          }}
        >
          {selectedAlert.id ? "Edit Alert" : "Add New Alert"}
        </h2>

        <UserViewEntry bare key={selectedAlert.id} handleClose={handleClose} alertId={0} />
      </div>
    </div>
  );
}

const styles = {
  banner: {
    display: "grid",
    gridTemplateColumns: "auto 1fr auto",
    alignItems: "center",
    backgroundColor: "#114E6B",
    color: "white",
    padding: "14px 16px",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    boxSizing: "border-box",
    overflowX: "hidden",
    zIndex: 1000,
  },

  logoContainer: {
    width: "40px",
    height: "40px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  titleContainer: {
    marginLeft: "8px",
    textAlign: "left",
  },

  title: {
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "1.2",
    color: "white",
  },

  subtitle: {
    fontSize: "16px",
    letterSpacing: "0.5px",
    opacity: 0.9,
    color: "white",
  },

  right: {
    justifySelf: "end",
    width: "40px",
  },

  content: {
    marginTop: "70px",
    padding: "16px",
  },

  pageTitle: {
    marginBottom: "20px",
    color: "#114E6B",
  },
};
